import React from 'react';

export default function PaytableSelector({ isOpen, onClose, paytableNames, currentPaytable, onSelectPaytable, onAddNew, isPremium = true }) {
  if (!isOpen) {
    return null;
  }

  const PREMIUM_PAYTABLES = ['810', '838'];

  const handleSelect = (paytableName) => {
    onSelectPaytable(paytableName);
    onClose();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '300px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <h2 style={{ marginTop: 0 }}>Select Pay Table</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
          {paytableNames.map(name => {
            const restricted = !isPremium && PREMIUM_PAYTABLES.includes(name);
            return (
              <button
                key={name}
                onClick={() => !restricted && handleSelect(name)}
                disabled={restricted}
                title={restricted ? 'Premium feature — upgrade to access this pay table' : ''}
                style={{
                  padding: '12px',
                  fontSize: '16px',
                  cursor: restricted ? 'not-allowed' : 'pointer',
                  border: currentPaytable === name ? '2px solid #007bff' : '1px solid #ccc',
                  backgroundColor: restricted ? '#f0f0f0' : (currentPaytable === name ? '#e7f3ff' : 'white'),
                  borderRadius: '4px',
                  fontWeight: currentPaytable === name ? 'bold' : 'normal',
                  textAlign: 'left',
                  color: restricted ? '#aaa' : 'inherit',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                {name}{restricted && <span style={{ fontSize: '0.75rem', color: '#b8860b' }}>★ Premium</span>}
              </button>
            );
          })}
        </div>
        <button
          onClick={() => {
            if (!isPremium) return;
            onAddNew();
            onClose();
          }}
          disabled={!isPremium}
          title={!isPremium ? 'Premium feature — upgrade to create custom pay tables' : ''}
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '12px',
            backgroundColor: isPremium ? '#28a745' : '#888',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: isPremium ? 'pointer' : 'not-allowed',
            fontWeight: '600',
            fontSize: '14px'
          }}
        >
          Add New Pay Table{!isPremium && ' ★'}
        </button>
        <button onClick={onClose} style={{
          padding: '8px 16px',
          backgroundColor: '#f0f0f0',
          border: '1px solid #ccc',
          borderRadius: '4px',
          cursor: 'pointer',
          width: '100%'
        }}>
          Cancel
        </button>
      </div>
    </div>
  );
}
